import EmbeddedVideo from 'components/features-page/EmbeddedVideo'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactElement } from 'react'
import getEnglishStrings from 'utils/getEnglishStrings'
import useOSType from 'utils/useOSType'

export default function FeatureVideo(): ReactElement {
  const osType = useOSType()
  const videoTitleData = useStaticQuery(graphql`
    query DesktopVideoTitle {
      directus {
        desktop_page {
          strings {
            languages_code {
              code
            }
            windows_video_title
            macos_video_title
          }
        }
      }
    }
  `)

  const desktopFeaturesData = getEnglishStrings(videoTitleData?.directus?.desktop_page?.strings)

  if (osType === 'linux') {
    return <></>
  }

  return (
    <EmbeddedVideo
      videoSrc={
        osType === 'windows'
          ? 'https://www.youtube.com/embed/IrFnvNVdqF4'
          : 'https://www.youtube.com/embed/djyBRjPgqVA'
      }
    />
  )
}
